import axios from "axios";

export async function retornarEnderecoPeloCep(cep) {
  try {
    const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    return response.data;
  } catch (error) {
    // Tratar erros de requisição
    console.error("Erro ao obter endereço:", error);
    return null;
  }
}
